import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/Button';
const galleryItems = [{
  id: 1,
  title: 'Elegant Cornrows',
  image: 'https://cdn.magicpatterns.com/uploads/oPcjCp9rNhyi11miaW2wZo/istockphoto-1618291225-612x612.webp'
}, {
  id: 2,
  title: 'Cornrow Braiding',
  image: 'https://cdn.magicpatterns.com/uploads/2Rg35apmrhiBC7SirPQpSB/istockphoto-183341611-612x612.webp'
}, {
  id: 3,
  title: 'Box Braids with Beads',
  image: 'https://cdn.magicpatterns.com/uploads/4HrN3tu5KNpG8RhMYChL1b/istockphoto-1352674262-612x612.webp'
}, {
  id: 4,
  title: 'Braided Updo',
  image: 'https://cdn.magicpatterns.com/uploads/st4oeS41uakBMn5Py2Y32u/istockphoto-1333647263-612x612.webp'
}, {
  id: 5,
  title: 'Detailed Cornrows',
  image: 'https://cdn.magicpatterns.com/uploads/mYcGRmj7PyBLcwuLLFXpAV/istockphoto-183332797-612x612.webp'
}, {
  id: 6,
  title: 'Braids with Design',
  image: 'https://cdn.magicpatterns.com/uploads/aQStPq7UhC3dBDPkZSknxz/istockphoto-1256553670-612x612.jpg'
}, {
  id: 7,
  title: 'Side Braid Style',
  image: 'https://cdn.magicpatterns.com/uploads/tGErXKv5tYnexYUuxYDfJC/side-view-image-of-beautiful-braid-hair.jpg'
}, {
  id: 8,
  title: 'Micro Braids',
  image: 'https://cdn.magicpatterns.com/uploads/8fkvPTEFH3AeLLB7R8gZQW/istockphoto-958683514-612x612.jpg'
}, {
  id: 9,
  title: 'Long Braids',
  image: 'https://cdn.magicpatterns.com/uploads/vuTG195XiLqBgVUgSo55rG/istockphoto-1328500183-612x612.webp'
}, {
  id: 10,
  title: 'Faux Locs',
  image: 'https://cdn.magicpatterns.com/uploads/87rXMcBwVohMSGNCqWzK4j/istockphoto-1312551586-612x612.webp'
}, {
  id: 11,
  title: 'Braiding in Progress',
  image: 'https://cdn.magicpatterns.com/uploads/nGqjW7ZGQhk1ekNjuKRTGT/istockphoto-2254725453-612x612.jpg'
}, {
  id: 12,
  title: 'Box Braid Styling',
  image: 'https://cdn.magicpatterns.com/uploads/9HJ51oQBNvS7NQJc6RsA29/istockphoto-1370569973-2048x2048.jpg'
}];
export { galleryItems };
interface GallerySectionProps {
  showAll?: boolean;
}
export function GallerySection({
  showAll = false
}: GallerySectionProps) {
  const navigate = useNavigate();
  const displayItems = showAll ? galleryItems : galleryItems.slice(0, 6);
  return <section id="gallery" className="py-24 bg-cream" data-id="element-151">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        {!showAll && <div className="flex flex-col md:flex-row md:items-end justify-between mb-12" data-id="element-153">
            <div className="max-w-2xl" data-id="element-154">
              <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="text-4xl md:text-5xl font-heading font-bold text-jet mb-4" data-id="element-155">
                Our Portfolio
              </motion.h2>
              <motion.p initial={{
            opacity: 0
          }} whileInView={{
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2
          }} className="text-brown text-lg" data-id="element-156">
                A glimpse into the artistry and precision of our master
                braiders.
              </motion.p>
            </div>
            <motion.div initial={{
          opacity: 0
        }} whileInView={{
          opacity: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.3
        }} className="mt-6 md:mt-0" data-id="element-157">
              <a href="https://instagram.com" target="_blank" rel="noopener noreferrer" className="text-burgundy font-medium hover:text-golden transition-colors flex items-center gap-2" data-id="element-158">
                Follow us on Instagram →
              </a>
            </motion.div>
          </div>}

        {/* Grid: 1 col mobile, 2 col tablet, 3 col desktop */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-159">
          {displayItems.map((item, index) => <motion.div key={item.id} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.08
        }} className="relative w-full aspect-[4/5] rounded-sm overflow-hidden group cursor-pointer" data-id="element-160">
              <img src={item.image} alt={item.title} className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-161" />

              {/* Gradient Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-jet/80 via-jet/20 to-transparent opacity-60 group-hover:opacity-80 transition-opacity duration-500" data-id="element-162"></div>

              {/* Content */}
              <div className="absolute inset-0 p-6 flex flex-col justify-end translate-y-4 group-hover:translate-y-0 transition-transform duration-500" data-id="element-163">
                <div className="w-8 h-1 bg-golden mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-100" data-id="element-164"></div>
                <h3 className="text-xl font-heading font-bold text-cream opacity-0 group-hover:opacity-100 transition-opacity duration-500 delay-200" data-id="element-165">
                  {item.title}
                </h3>
              </div>
            </motion.div>)}
        </div>

        {/* View All Button - only on homepage */}
        {!showAll && <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-12 flex justify-center" data-id="element-166">
            <Button variant="outline" size="lg" onClick={() => navigate('/gallery')} data-id="element-167">
              View All Gallery
            </Button>
          </motion.div>}
      </div>
    </section>;
}